import React from 'react';
import {Chip} from '@mui/material';

export default React.memo(Chip);
